import React from 'react';

import { ItemType } from 'Shared/constants/types';

import './WorkspaceItemParentInfo.scss';

type Props = {
  workspacePath: string;
  parentText: string;
  parentUuid: string;
  itemType: ItemType;
};

function WorkspaceItemParentInfo({ workspacePath, itemType, parentText, parentUuid }: Props) {
  const parentItemWorkspacePath = `${workspacePath}/item/${parentUuid}`;
  return (
    <div className="your-action-item-parent-info pb-1">
      <span className="mr-2">{itemType === ItemType.actionItem ? 'Sub-item of:' : 'Sub-topic of:'}</span>
      <a href={parentItemWorkspacePath} target="_blank" rel="noopener noreferrer">
        {parentText || '(Empty item)'}
      </a>
    </div>
  );
}

export default WorkspaceItemParentInfo;
